import Vue from 'vue'
import App from './App.vue'
// 导入vant
import Vant, { Locale } from 'vant'
// 引入组件库
import zhCN from 'vant/es/locale/lang/zh-CN'
// 导入路由
import router from './router/index'
// 导入vuex
import store from './store/index'
// 移动端适配
import 'lib-flexible'

// 全局样式
import 'vant/lib/index.css'
import './assets/style/variable.scss'
import './assets/style/index.scss'

Vue.config.productionTip = false

// import Vconsole from 'vconsole'
// new Vconsole()

Vue.use(Vant)
Locale.use('zh-CN', zhCN)

// 全局横屏指令
Vue.directive('horizontal-screen', {
  bind(el) {
    // let self = vnode.context

    let getDocumentSize = () => [
      document.documentElement.clientWidth,
      document.documentElement.clientHeight
    ]

    // 设备开启竖屏锁定，强制横屏模式
    let vertical = () => {
      let [width, height] = getDocumentSize()
      el.style.transform = `rotate(90deg)`
      el.style.transformOrigin = width / 2 + 'px center'
      el.style.width = height + 'px'
      el.style.height = width + 'px'
    }

    // 设备关闭竖屏锁定，横屏时，还原成正常模式
    let reset = () => {
      let [width, height] = getDocumentSize()
      el.style.transform = `rotate(0deg)`
      el.style.width = `${width}px`
      el.style.height = `${height}px`
    }

    let isMobile = () => {
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        return true
      }
      return false
    }

    el.resize = function () {
      if (document.activeElement.nodeName === 'INPUT') return // 兼容安卓

      window.calcFontSize()

      if (isMobile()) {
        if ([null, 180, 0].includes(window.orientation)) {
          vertical()
        } else if ([90, -90].includes(window.orientation)) {
          reset()
        }
      } else {
        reset()
      }
    }

    el.resize()

    el.click = (e) => {
      if (isMobile()) {
        if (e.target.nodeName === 'INPUT') {
          reset()
        } else if (![90, -90].includes(window.orientation)) {
          vertical()
        }
      } else {
        reset()
      }
    }

    window.addEventListener('click', el.click, false)
    window.addEventListener('resize', el.resize, false) // 兼容安卓
    window.addEventListener('orientationchange', el.resize, false)
  },

  unbind(el) {
    window.removeEventListener('click', el.click, false)
    window.removeEventListener('resize', el.resize, false)
    window.removeEventListener('orientationchange', el.resize, false)
  }
})

// 微信分享
import ShareImpl from './utils/wx'
Vue.prototype.ShareImpl = ShareImpl

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
